import React, { ComponentProps } from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export const OutlookLogo = ({ width = 24, height = 24, ...restProps }: ComponentProps<typeof SvgIcon>) => (
  <SvgIcon {...restProps} viewBox={`0 0 ${width} ${height}`}>
    <path
      d="M10.5 15.5C10.5 16.052 10.948 16.5 11.5 16.5H20C20.552 16.5 21 16.052 21 15.5V8C21 7.448 20.552 7 20 7H11.5C10.948 7 10.5 7.448 10.5 8V15.5Z"
      fill="#03A9F4"
    />
    <path
      d="M21 8.48728V7.99978C21 7.78578 20.9315 7.58828 20.8165 7.42578L15.1845 10.8918L11.4135 8.56378L11.0625 9.49978L15.292 11.9998L21 8.48728Z"
      fill="#B3E5FC"
    />
    <path d="M13.5 20.73L3 18.73V4.72998L13.5 2.72998V20.73Z" fill="#0277BD" />
    <path
      d="M10.608 9.15572C10.059 8.51822 9.335 8.19922 8.444 8.19922C7.498 8.19922 6.74 8.53372 6.167 9.20072C5.595 9.86922 5.3075 10.7447 5.3075 11.8237C5.3075 12.8462 5.5895 13.6807 6.1525 14.3167C6.7155 14.9532 7.4485 15.2717 8.3415 15.2717C9.2615 15.2717 10.007 14.9457 10.5785 14.2842C11.15 13.6277 11.4345 12.7627 11.4345 11.6847C11.4345 10.6407 11.159 9.79772 10.608 9.15572ZM9.5245 13.3677C9.2405 13.7522 8.855 13.9437 8.368 13.9437C7.8985 13.9437 7.5185 13.7467 7.2255 13.3502C6.935 12.9577 6.7905 12.4197 6.7905 11.7447C6.7905 11.0767 6.935 10.5377 7.2255 10.1322C7.5185 9.72722 7.9095 9.52672 8.403 9.52672C8.884 9.52672 9.262 9.72322 9.5365 10.1157C9.814 10.5132 9.953 11.0632 9.953 11.7707C9.9535 12.4532 9.809 12.9842 9.5245 13.3677Z"
      fill="white"
    />
  </SvgIcon>
)
